import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  Renderer2,
  ViewChild
} from "@angular/core";
import {RouterService} from "../../services/router.service";
import {NgxPermissionsService} from "ngx-permissions";

require('./bringoz-state-link.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-state-link',
  templateUrl: './bringoz-state-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozStateLinkComponent implements AfterViewInit {

  @Input() state: string;
  @Input() params: any;
  @Input() text: string;
  @Input() permission: string | string[];
  @Input() openInNewTab: boolean;

  @Output() linkClick = new EventEmitter<void>();

  @ViewChild('stateLink', {static: false}) stateLink!: ElementRef;

  constructor(@Inject('$state') public $state, @Inject(RouterService) private routerService: RouterService,
              @Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService,
              @Inject(Renderer2) private renderer: Renderer2) {
  }


  ngAfterViewInit() {
    if (!!this.permission) {
      this.permissionsService.hasPermission(this.permission).then((hasPermission) => {
        if (!hasPermission) {
          this.renderer.addClass(this.stateLink.nativeElement, 'disabled');
        }
      });
    }
  }

  onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.linkClick.emit();
    if (this.openInNewTab) {
      this.routerService.routeToNewTab(this.state, this.params);
    } else {
      this.routerService.routeTo(this.state, this.params);
    }
  }

}
